import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { Trash2, Check, X, Loader, AlertOctagon } from 'lucide-react';

export default function AdminTakedownsPage() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { try { const { data } = await api.get('/takedowns'); setRequests(data.requests || []); } catch (e) {} finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  const process = async (id, status, notes = '') => {
    try { await api.post(`/takedowns/${id}/process`, { status, admin_notes: notes }); toast.success(status === 'approved' ? 'Takedown approvato — release rimossa' : 'Takedown rifiutato'); load(); }
    catch (err) { toast.error('Errore'); }
  };

  const del = async (id) => {
    if (!window.confirm('Eliminare questa richiesta?')) return;
    try { await api.delete(`/takedowns/${id}`); toast.success('Eliminata'); load(); }
    catch (err) { toast.error('Errore'); }
  };

  const statusColors = { requested: 'bg-yellow-600', approved: 'bg-green-600', rejected: 'bg-red-600' };
  const statusLabels = { requested: 'In Attesa', approved: 'Approvato', rejected: 'Rifiutato' };
  const reasonLabels = { legal: 'Motivi legali', data_error: 'Errore dati', artist_decision: 'Decisione artista', copyright: 'Copyright', other: 'Altro' };

  if (loading) return <div className="flex justify-center py-16"><Loader size={24} className="animate-spin text-yellow-400" /></div>;

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6 flex items-center gap-2"><AlertOctagon size={24} className="text-orange-400" />Take Down ({requests.length})</h1>
      {requests.length === 0 ? <div className="card-dark p-12 text-center text-gray-500">Nessuna richiesta</div> : (
        <div className="space-y-3">{requests.map(r => (
          <div key={r.id} className="card-dark p-5">
            <div className="flex items-center gap-4 mb-3">
              <AlertOctagon size={20} className="text-orange-400 flex-shrink-0" />
              <div className="flex-1">
                <p className="font-bold text-white">{r.release_title}</p>
                <p className="text-xs text-gray-400">{r.first_name} {r.last_name} ({r.email}) · {new Date(r.requested_at).toLocaleDateString('it-IT')}</p>
              </div>
              <span className={`text-[10px] px-2.5 py-1 rounded-full text-white ${statusColors[r.status]}`}>{statusLabels[r.status]}</span>
            </div>
            <div className="bg-gray-900 rounded-lg p-3 mb-3 text-xs text-gray-300">
              <p><strong>Motivo:</strong> {reasonLabels[r.reason] || r.reason}</p>
              {r.notes && <p className="mt-1"><strong>Note:</strong> {r.notes}</p>}
              {r.admin_notes && <p className="mt-1 text-yellow-400"><strong>Risposta admin:</strong> {r.admin_notes}</p>}
            </div>
            <div className="flex gap-2 justify-end">
              {r.status === 'requested' && (<>
                <button onClick={() => process(r.id, 'approved')} className="px-3 py-1.5 bg-green-600 text-white text-xs rounded-lg hover:bg-green-700 flex items-center gap-1"><Check size={12} />Approva</button>
                <button onClick={() => { const n = prompt('Motivo rifiuto (opzionale):'); process(r.id, 'rejected', n || ''); }} className="px-3 py-1.5 bg-red-600 text-white text-xs rounded-lg hover:bg-red-700 flex items-center gap-1"><X size={12} />Rifiuta</button>
              </>)}
              <button onClick={() => del(r.id)} className="px-3 py-1.5 bg-red-900/50 text-red-300 text-xs rounded-lg hover:bg-red-900 flex items-center gap-1"><Trash2 size={12} />Elimina</button>
            </div>
          </div>
        ))}</div>
      )}
    </div>
  );
}
